export class ChatStorageService {
  static storageKey = 'idb-aurora-chat';

  static getMessages() {
    const data = localStorage.getItem(this.storageKey);
    return data ? JSON.parse(data) : [];
  }

  static addMessage(newMessage: { text: string; isUser: boolean }) {
    const messages = this.getMessages();
    messages.push(newMessage);
    localStorage.setItem(this.storageKey, JSON.stringify(messages));
    window.dispatchEvent(new CustomEvent('chatStorageUpdated'));
  }

  static saveMessages(messages: Array<{ text: string; isUser: boolean }>) {
    localStorage.setItem(this.storageKey, JSON.stringify(messages));
    window.dispatchEvent(new CustomEvent('chatStorageUpdated'));
  }
}
